export const CONTRACT_TYPE = {
  CONTRACT_ALL_IN: {
    key: 'CONTRACT_ALL_IN',
    name: 'Contract All In',
  },
  CONTRACT_ON_CALL: {
    key: 'CONTRACT_ON_CALL',
    name: 'Contract on Call',
  },
  ON_CALL: {
    key: 'ON_CALL',
    name: 'On Call',
  },
  LEASED_OUT: {
    key: 'LEASED_OUT',
    name: 'Leased Out',
  },
}

const contractTypes = [
  {
    key: 'CONTRACT_ALL_IN',
    name: 'Contract All In',
  },
  {
    key: 'CONTRACT_ON_CALL',
    name: 'Contract on Call',
  },
  {
    key: 'ON_CALL',
    name: 'On Call',
  },
  {
    key: 'LEASED_OUT',
    name: 'Leased Out',
  },
]

export default contractTypes;